module.exports = __webpack_public_path__ + "img/course124_curriculum.8e4852de.png";